import type { Infer } from 'superstruct';
import { assign, object, optional, pick, string } from 'superstruct';

import {
	PaginationQueryDefaulted,
	UnsafeSortQueryDefaulted,
} from '@adflow/shared/util-data';
import {
	isoDateTimeWithCoercions,
	parsableArray,
	parsableBoolean,
	parsableInteger,
} from '@adflow/shared/util-superstruct';

export const UserFilterDto = object({
	archived: optional(parsableBoolean()),
	loggedInAfter: optional(isoDateTimeWithCoercions()),
	loggedInBefore: optional(isoDateTimeWithCoercions()),
	search: optional(string()),

	/**
	 * When this is non-empty, return only users with at least one of the specified roles.
	 */
	roles: optional(parsableArray(parsableInteger())),
});

export type UserFilterDto = Infer<typeof UserFilterDto>;

export const UserListFilterDto = assign(
	PaginationQueryDefaulted(10),
	UnsafeSortQueryDefaulted('name', 'asc'),
	UserFilterDto
);

export type UserListFilterDto = Infer<typeof UserListFilterDto>;

export const UserListFrontendFilterDto = pick(UserListFilterDto, [
	'archived',
	'loggedInAfter',
	'loggedInBefore',
]);

export type UserListFrontendFilterDto = Infer<typeof UserListFrontendFilterDto>;
